import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { AppRegistrationStartPage } from './app-registration-start';
import {PipesModule} from "../../pipes/pipes.module";
import {DirectivesModule} from "../../directives/directives.module";

@NgModule({
  declarations: [
    AppRegistrationStartPage,
  ],
  imports: [
    IonicPageModule.forChild(AppRegistrationStartPage),
    PipesModule,
    DirectivesModule,
  ],
})
export class AppRegistrationStartPageModule {}



// WEBPACK FOOTER //
// ./src/pages/app-registration-start/app-registration-start.module.ts